import React, { Dispatch, SetStateAction, useEffect } from "react";
import styles from "./index.module.scss";

interface ScrollingCountdownProps {
  onComplete: () => void;
  isVisible: boolean;
  setCurrent: Dispatch<SetStateAction<number>>;
  current: number | null;
}

const ScrollingCountdown: React.FC<ScrollingCountdownProps> = ({
  onComplete,
  isVisible,
  current,
  setCurrent,
}) => {
  //const [current, setCurrent] = useState<number | null>(null);

  const itemHeight = 72 + 35; // height + gap = 108px
  const offset = 205 / 2 - itemHeight / 3; // center offset = 48.5px

  useEffect(() => {
    if (!isVisible) return;
    setCurrent(11);
  }, [isVisible]);

  useEffect(() => {
    //if (current === null || current <= 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => {
        if (prev === null || prev === 0) {
          console.log(prev, "prev");
          clearInterval(interval);
          onComplete();
          return -1; // remove from DOM after countdown
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [current, onComplete]);
  console.log("current", current);
  if (!isVisible || current === null || current < -1) return null;

  const numbers = Array.from({ length: 12 }, (_, i) => 11 - i);

  return (
    <div className={styles.countdown_container}>
      <div className={styles.countdown_content}>
        <span>will start in</span>
        <div className={styles.fade_scroll_container}>
          <div
            className={styles.scroll_wrapper}
            style={{
              transform: `translateY(calc(${offset}px - ${(11 - current) * itemHeight}px))`,
              transition: "transform 0.5s ease-in-out",
              gap: `36px`,
            }}
          >
            {numbers.map((num) => (
              <div
                key={num}
                className={`${styles.number} ${
                  num === current ? styles.current : styles.adjacent
                }`}
              >
                {num}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollingCountdown;
